var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.5C11 12.2239 11.1865 12 11.4167 12H20.5833C20.8135 12 21 12.2239 21 12.5C21 12.7761 20.8135 13 20.5833 13H11.4167C11.1865 13 11 12.7761 11 12.5Z",
    fill: "#001024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.5C11 18.2239 11.1865 18 11.4167 18H20.5833C20.8135 18 21 18.2239 21 18.5C21 18.7761 20.8135 19 20.5833 19H11.4167C11.1865 19 11 18.7761 11 18.5Z",
    fill: "#001024"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.5C11 15.2239 11.1865 15 11.4167 15H20.5833C20.8135 15 21 15.2239 21 15.5C21 15.7761 20.8135 16 20.5833 16H11.4167C11.1865 16 11 15.7761 11 15.5Z",
    fill: "#001024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.267e657b21d83e69561490e89023669d.svg";
export { ForwardRef as ReactComponent };